export const STICKY_ACTION_COLUMN_MAX_WIDTH = 60;
export const MAX_CELL_WIDTH = 2000;
